export class ModifyLimitResponseDTO{


    constructor(data: ModifyLimitResponseDTO){
        Object.assign(this, data);
    }
}